import { isMockMode, post, simulateDelay } from "../../api";

export interface CreateFeatureRequest {
	productId: string;
	code: string;
	name: string;
	description: string;
	defaultValue: boolean;
}

export const createFeature = (req: CreateFeatureRequest) => {
	req.defaultValue = req.defaultValue ?? false;
	if (isMockMode()) {
		const testData = { success: true };

		return simulateDelay(50, () => testData);
	}

	return post(`products/createFeature`, req);
};
